// extracted by mini-css-extract-plugin
export default {"bypassBlock":"styles__bypassBlock___QXCv3","focus-visible":"styles__focus-visible___LdRCt","forceFocusForStorybook":"styles__forceFocusForStorybook___OeaUB"};